/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Admin_Commission_Quarter_Open_Month_NoteInputs */



/**
* | output |
* | --- |
* | "{count} entry on the current open month is excluded — it carries an adjustment and settles when the month closes." |
*
* @param {Partner_Admin_Commission_Quarter_Open_Month_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_quarter_open_month_note = /** @type {((inputs: Partner_Admin_Commission_Quarter_Open_Month_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Quarter_Open_Month_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Eintrag im laufenden Monat ist ausgenommen — er trägt eine Korrektur und wird mit Monatsende abgeschlossen.`)
	return /** @type {LocalizedString} */ (`${i?.count} entry on the current open month is excluded — it carries an adjustment and settles when the month closes.`)
});